module.exports = "<a href=\"#\" (click)=\"$event.preventDefault();router.navigate(['/racesnew'])\">Nový</a>\n<table class=\"table table-bordered table-responsive\">\n  <th>Jméno</th>\n  <th>Aktivovat</th>\n  <tr *ngFor=\"let race of races\">\n    <td>{{race.name}}</td>\n    <td *ngIf=\"race.active\"><a href=\"#\" (click)=\"$event.preventDefault();activate(race.id, false)\">Deaktivovat</a></td>\n    <td *ngIf=\"!race.active\"><a href=\"#\" (click)=\"$event.preventDefault();activate(race.id, true)\">Aktivovat</a></td>\n  </tr>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/races-list/races-list.component.html
// module id = 462
// module chunks = 1